module.exports = __webpack_public_path__ + "img/3.0e6c0a02.jpg";